"use client";

import { useFormStatus } from "react-dom";

import { Button } from "@/components/button/button.component";

export function AddToCartSubmitButton({
  productType,
}: AddToCartSubmitButtonProps) {
  const { pending } = useFormStatus();
  return (
    <Button
      secondary
      type="submit"
      loading={pending}
      disabled={pending}
      className="w-full text-sm whitespace-nowrap">
      {productType === "camera" ? "Add to Cart" : "Build my system"}
    </Button>
  );
}

type AddToCartSubmitButtonProps = {
  productType?: string | null;
};
